module.exports = __webpack_public_path__ + "static/media/arrow-top.4bff7167.svg";